/** E5 (spec 2026-09-20-e5 §5.5): the two pieces of copy a restricted field
 * wears, in one place. The server withholds the value (`redacted: true`,
 * `value: null`); the UI only says so — it never decides what is restricted. */
export const RESTRICTED_VALUE = 'Restricted'
export const RESTRICTED_TASK = 'Working this task needs the pricing permission.'
